import { Injectable } from "@angular/core";
import { BlocksService } from "./blocks.service";

@Injectable()
export class SpeedCalculatorService {
 
  public MAXSPEED = 10;
  public MINSPEED = 0;

  constructor(private blocks: BlocksService) {    
  }

    
  public calculateCurrentspeed() {
    let val = parseInt(
      (<HTMLInputElement>document.getElementById("speedRange")).value
    );
    let prec = 0.95; // at 95% speed we will switch to very fast
    
    /* {speed} should be from 1000 (slow) to 0 (fast) or even negative (very fast)*/
    
    let factor = this.blocks.isBlockMode() ? 600 : 100; // slower speed in blocks mode
    let speed =
      val / this.MAXSPEED > prec
        ? -1
        : Math.pow((this.MAXSPEED - val) / this.MAXSPEED, 4.5) *
          this.MAXSPEED *
          factor;
    return speed;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/speedcalculator.service.ts